import type { OrderFilterDto } from "Infrastructure/Api/Api";
import { getOrderCommentsByOrderIdQueryKey } from "Order/Api/Query/useOrderCommentsByOrderIdQuery";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { getOrderPartnerAllocationsQueryKey } from "Order/Api/Query/useOrderPartnerAllocationsQuery";
import { getOrderPhotosQueryKey } from "Order/Api/Query/useOrderPhotosQuery";
import {
	getOrdersListQueryKey,
	ORDER_LIST,
} from "Order/Api/Query/useOrdersListQuery";
import { getOrderTimelineQueryKey } from "Order/Api/Query/useOrderTimelineQuery";
import { getOrderPartnerReviewByOrderIdQueryKey } from "Order/Api/Query/usePartnerReviewByOrderIdQuery";
import { CLAIM_BY_ID } from "Order/Modules/Claim/Api/Query/getClaimByIdQuery";
import { CLAIM_BY_ORDER_ID } from "Order/Modules/Claim/Api/Query/getClaimsByOrderIdQuery";
import { getOrderExaminationByOrderIdQueryKey } from "Order/Modules/Examination/Api/Query/useOrderExaminationByOrderIdQuery";
import { getOrderFeeQueryKey } from "Order/Modules/Payment/Api/Query/useOrderFeeQuery";
import { getOrderPriceByOrderIdQueryKey } from "Order/Modules/Price/Api/Query/useGetOrderPriceByOrderIdQuery";

export const orderKeys = {
	// Global prefix target for future unification. Currently used only for grouping.
	all: ["orders"] as const,
	// List keys (backwards-compatible with existing implementation)
	list: (filters: Partial<OrderFilterDto> = {}) =>
		getOrdersListQueryKey(filters as OrderFilterDto),
	listAll: [ORDER_LIST] as const,
	// Detail-family keys
	detail: (orderId: number) => getOrderDetailQueryKey(orderId),
	partnerAllocations: (orderId: number) =>
		getOrderPartnerAllocationsQueryKey(orderId),
	timeline: (orderId: number) => getOrderTimelineQueryKey(orderId),
	comments: (orderId: number) => getOrderCommentsByOrderIdQueryKey(orderId),
	price: (orderId: number) => getOrderPriceByOrderIdQueryKey(orderId),
	review: (orderId: number) => getOrderPartnerReviewByOrderIdQueryKey(orderId),
	examinations: (orderId: number) =>
		getOrderExaminationByOrderIdQueryKey(orderId),
	fee: (orderId: number) => getOrderFeeQueryKey(orderId),
	photos: (orderId: number) => getOrderPhotosQueryKey(orderId),
	// Claims
	claimById: (claimId: number) => [CLAIM_BY_ID, claimId] as const,
	claimsByOrder: (orderId: number) => [CLAIM_BY_ORDER_ID, orderId] as const,
} as const;

export type OrderKeys = typeof orderKeys;
